import { Box, Chip, Stack, Typography } from "@mui/material";
import { useContext } from "react";
import SessionContext from "../layout/SessionContext";
import useUserClubs from "./useUserClubs";

/** Shown in place of club-specific content when a player has "All clubs" selected. */
function ClubPickerPrompt({ devPort, message }: { devPort: string; message: string }) {
  const { userName, selectClubManually } = useContext(SessionContext);
  const { state } = useUserClubs(devPort, userName, "player");
  const clubs = state.status === "ready" ? state.clubs : [];

  return (
    <Box
      data-testid="club-picker-prompt"
      sx={{
        p: 3,
        borderRadius: 2,
        border: "1px dashed",
        borderColor: "divider",
        textAlign: "center",
      }}
    >
      <Typography sx={{ mb: 2 }}>{message}</Typography>
      <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap" justifyContent="center">
        {clubs.map((club) => (
          <Chip
            key={club.value}
            label={club.label}
            color="primary"
            variant="outlined"
            onClick={() => selectClubManually(club.value)}
            data-testid={"club-picker-" + club.value}
          />
        ))}
      </Stack>
    </Box>
  );
}

export default ClubPickerPrompt;
